import Collection from '@/components/Collection';
import ConfirmDomainPendingCreate from '@/components/ConfirmDomainPendingCreate';
import access from "../access";

const domainNs = "urn:ietf:params:xml:ns:domain-1.0";

export default {

  'request.collection': {
    path: '/admin/requests',
    name: 'request.collection',
    component: Object.assign({}, Collection), // https://stackoverflow.com/a/41425312
    props: {
      handler: "listPendingRequests",
      entity: "request",
      cols: [
        {label: "Created", field: "request_date", date: "date"},
        {label: "Expires", field: "valid_until_date", date: "date"},
        {
          label: "Domain",
          component: "router-link",
          componentProps: (row) => {
            return {
              to: {
                name: "domain.view",
                params: {
                  domain: row.domain,
                },
              },
              content: row.domain
            }
          },
        },
        {label: "Status", html: (row) => row.domain_status.join('<br>')},
        {
          label: "Requester",
          component: "RouteLabelConverter",
          componentProps: (row) => {
            return {
              request: {registrar_id: row.requesting_registrar},
              placeholder: row.requesting_registrar,
              call: "viewRegistrar",
              handler: function(data) {
                return data.name + ", " + data.org;
              },
              route: {
                to: {
                  name: "registrar.view",
                  params: {
                    id: row.requesting_registrar,
                  },
                },
              }
            };
          },
        },
        {
          label: "Owner",
          component: "RouteLabelConverter",
          componentProps: (row) => {
            return {
              request: {registrar_id: row.owner_registrar},
              placeholder: row.owner_registrar,
              call: "viewRegistrar",
              handler: function(data) {
                return data.name + ", " + data.org;
              },
              route: {
                to: {
                  name: "registrar.view",
                  params: {
                    id: row.owner_registrar,
                  },
                },
              }
            };
          },
        },
        {
          label: "",
          component: ConfirmDomainPendingCreate,
          componentProps: (row) => {
            return {
              domain: row.domain,
            }
          },
        },
      ]
    },
    meta: {
      access: access.chain(access.admin, access.service(domainNs)),
      title: "Pending requests list",
      side_menu: {label: "Pending requests", icon: "stopwatch"},
    },
  },

}



// WEBPACK FOOTER //
// ./src/routes/modules/request.js